import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Button from "../common/Button";

const PlusMinButtons = (props) => {

	const { size,
		fullWidth,
		disabled,
		onMinButtonClick,
		onPlusButtonClick,
		minButtonEnabled,
		plusButtonEnabled } = props;

	const minButton = minButtonEnabled ?
		<Button onClick={onMinButtonClick} disabled={disabled} text="-" className="c-button--input min" /> : null;
	const plusButton = plusButtonEnabled ?
		<Button onClick={onPlusButtonClick} disabled={disabled} text="+" className="c-button--input plus" /> : null;
	const totalColumnsCount = 12;

	let buttonClassNames = {
		["o-col-" + size]: true,
		["o-col-push-" + size]: (!fullWidth && !plusButton && minButton) || (!fullWidth && plusButton && !minButton)
	};

	let minButtonClassNames = {
		["o-col-push-" + (totalColumnsCount - (size * 2))]: (fullWidth && minButton && plusButton),
		["o-col-push-" + (totalColumnsCount - (size))]: (fullWidth && minButton && !plusButton)
	};

	let plusButtonClassNames = {
		["o-col-push-" + (totalColumnsCount - (size))]: (fullWidth && !minButton && plusButton)
	};

	return (
		<div>
			{minButton ?
				<div className={classnames(buttonClassNames, minButtonClassNames)}>
					{minButton}
				</div> : null}
			{plusButton ?
				<div className={classnames(buttonClassNames, plusButtonClassNames)}>
					{plusButton}
				</div> : null}
		</div>
	);
};

PlusMinButtons.propTypes = {
	minButtonEnabled: PropTypes.bool,
	plusButtonEnabled: PropTypes.bool,
	onMinButtonClick: PropTypes.func,
	onPlusButtonClick: PropTypes.func,
	disabled: PropTypes.bool,
	size: PropTypes.number,
	fullWidth: PropTypes.bool
};

PlusMinButtons.defaultProps = {
	size: 1
};

export default PlusMinButtons;
